import type { Subscription } from '../../types';
import { hasPlan as hasLegacyPlan } from '../legacySubscription/hasPlan';
import { hasPlan as hasModernPlan } from '../modernSubscription/hasPlan';

import { isModernSubscription } from './isModernSubscription';

/**
 * True when the subscription has a plan (active subscription, trial with plan, or pending cancel).
 * Includes free plans like Developer2025. For "has a paid plan", use hasPaidPlan instead.
 */
export function hasPlan(subscription: Subscription) {
  if (isModernSubscription(subscription)) {
    return hasModernPlan(subscription);
  }

  return hasLegacyPlan(subscription);
}
